import React, { useEffect, useRef, useState } from "react";
import { MoreOptionWrapper } from "./style";
import MoreIconTable from "../../assets/images/MoreIconTable";
import { useId } from "react";
import { clickOutSide } from "../../utils/common";

function MoreOptions({ options = [], items , parentClass="table-card-wrapper"}) {
  const [openMoreOptions, setOpenMoreOptions] = useState("");
  const id = useId();
  const boxRef = useRef();
  const [position, setPosition] = useState("top");

  useEffect(() => {
    if (!boxRef) return;
    clickOutSide(boxRef, () => setOpenMoreOptions(""));
    return clickOutSide(boxRef, () => setOpenMoreOptions(false), "remove");
  }, [boxRef]);

  useEffect(() => {
    if (!boxRef.current) return;
  
    const updatePosition = () => {
      const rect = boxRef.current?.getBoundingClientRect();
      const parentWrapper = boxRef.current?.closest("."+parentClass);
  
      if (!rect || !parentWrapper) return;
  
      const parentRect = parentWrapper.getBoundingClientRect();
  
      if (rect.bottom > parentRect.bottom) {
        setPosition("top");
      } else {
        setPosition("bottom");
      }
    };
  
    requestAnimationFrame(updatePosition);
  }, [boxRef.current]);
  



  return (
    <>
      <span className="card-th">Actions</span>
      <MoreOptionWrapper className={""}>
        <div
          onClick={() => setOpenMoreOptions(openMoreOptions === id ? "" : id)}
        >
          <MoreIconTable />
        </div>

        <div
          ref={boxRef}
          className={`options ${openMoreOptions === id ? "open" : ""} ${position}`}
        >
          <ul>
            {options &&
              options.map((value, index) => {
                if (!value?.show(items)) return "";
                return (
                  <li key={index} onClick={() => value.click(items)}>{typeof value?.label === 'function'?value?.label(items):value?.label}</li>
                );
              })}
          </ul>
        </div>
      </MoreOptionWrapper>
    </>
  );
}

export default MoreOptions;
